import styled from "styled-components"

import { HalfDoughnutLegendItem } from "./HalfDoughnutLegendItem"
import { HalfDoughnutSummaryItem } from "./styled"

const LegendGrid = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: 12px 24px;
`

interface HalfDoughnutLegendGridProps {
  items: HalfDoughnutSummaryItem[]
  total?: number
  columns?: number
}

export const HalfDoughnutLegendGrid = ({ items, total, columns = 2 }: HalfDoughnutLegendGridProps) => (
  <LegendGrid $columns={columns}>
    {items.map(item => (
      <HalfDoughnutLegendItem key={item.label} {...item} total={total} inline />
    ))}
  </LegendGrid>
)
